/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { FaGem } from "react-icons/fa";
import RecentOrderTbody from "./RecentOrderTbody";
export function RecentOrderDetails(props) {

  return (
    <>
      {/* begin::Advance Table Widget 9 */}
      <div className={`shadow-xs card card-custom card-stretch gutter-b`}>
        {/* begin::Header */}
        <div className="card-header">
          <div className="card-title align-items-center">
            <FaGem /> <h3 className="ml-3 mb-0" >Recent Order Details</h3>
          </div>
        </div>
        {/* end::Header */}

        {/* begin::Body */}
        <div className="card-body pt-0 pb-3">
          <div className="tab-content">
            {/* begin::Table */}
            <div className="table-responsive">
              <table className="table table-hover kycTable">
                <thead>
                  <tr>
                    <th className="">Status</th>
                    <th className="text-center">Date</th>
                    <th className="text-center">Order ID</th>
                    <th className="">Diamond details</th>
                    <th className="">Advanced tags</th>
                    <th className="text-right">Price</th>
                  </tr>
                </thead>
                {props.recentOrderData.length !== 0 ? 
                  <tbody>
                      {props.recentOrderData.slice(0, 5).map((val) => {
                          return(
                              <RecentOrderTbody 
                                  key={val.id}
                                  userinfo_timezone={props.userinfo.timezone}
                                  {...val}
                              />
                          );    
                      })}
                    </tbody> 
                  : <tbody><tr><td className="text-center border-bottom" colSpan="100%">No record found</td></tr></tbody> }
              </table>
            </div>
            {/* end::Table */}
          </div>
        </div>
        {/* end::Body */}
      </div>
      {/* end::Advance Table Widget 9 */}
    </>
  );
}
